export const GatorBackupActionTypes = {
  GATOR_BACKUP_LOADING: 'GATOR_BACKUP_LOADING',
  GATOR_BACKUP_BUY_REQUEST: 'GATOR_BACKUP_BUY_REQUEST',
  GATOR_BACKUP_BUY_SUCCESS: 'GATOR_BACKUP_BUY_SUCCESS',
  GATOR_BACKUP_BUY_FAILURE: 'GATOR_BACKUP_BUY_FAILURE',
  SSO_REQUEST: 'GATOR_BACKUP_SSO_REQUEST',
  SSO_SUCCESS: 'GATOR_BACKUP_SSO_SUCCESS',
  SSO_FAILURE: 'GATOR_BACKUP_SSO_FAILURE',
};
